import React from "react";

function NoItem({ titleText }) {
    return (
        <div className="clear infortxtbox2">
            <div className="fl infortxt3">{titleText}</div>
        </div>
    );
}

export default NoItem;
